import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { ApiPartnerService } from '../../api/api-partner.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-adminsb-maintenance',
  templateUrl: './adminsb-maintenance.component.html',
  styleUrls: ['./adminsuperbranch.component.css']
})
export class AdminsbMaintenanceComponent implements OnInit {

  CustomerList: any = {};
  changeForm = false;
  searchiserror = false;
  _changeForm: any = {};
  _oldDevice: any = {};
  _newDevice: any = {};
  _resultSearch: any = {};

  //pagination
  //paging_link : any = [];
  paging : any = {};
  msearch : string;
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  //end pagination

  table_load = true

  changePackageForm: FormGroup;

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router
  ) { 
  	
  }

  ngOnInit() {
  	this.loadStart()
  }

  loadStart() {
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        // console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          // console.log('search');
          // console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadCustomeractive(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          // console.log(this.queryParams);
          // console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadCustomeractive(this.queryParams);
        }
      });

    this.changePackageForm = this.formBuilder.group({
            id: [''],
            sn: [''],
            macaddress: [''],
            kondisi_lama: [''],
            note: ['']
        }, {
           
        });
  }

  refreshPage() {
    this.ngOnInit();
  }
  
  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  search()
  {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams+'&search='+this.msearch;
    this.loadCustomeractive(this.searchQueryParams);
  }

  searchloading = false;
  macaddress = '';
  searchBy(val)
  {
    console.log(this.changePackageForm.value);
    this.searchiserror = false;
    this.searchloading = true;
    return this.partnerService.SearchStb({sn: val}).subscribe((searchOut: []) => {
      console.log(searchOut);
      this._resultSearch = searchOut;
      if ( searchOut['status'] ){
        this.macaddress = searchOut['data']['macaddress'];
        this.changePackageForm.controls['macaddress'].setValue(this._resultSearch.data.macaddress);
        this.changePackageForm.controls['id'].setValue(this._resultSearch.data.id);
        console.log(this.changePackageForm.value);
      }else{
        this.searchiserror = true;
        this.macaddress = '';

      }
      this.searchloading = false;
    })
  }


  onChangepackage(_it:any, el: HTMLElement)
  {
    this.changeForm = true;
    this._changeForm = _it;
    this._oldDevice = _it;
    console.log(this._changeForm);

    setTimeout(()=>{
      el.scrollIntoView({behavior:"smooth"})
    }, 100);

  }

  changedeviceloading = false;
  changeSubmitPrepaid()
  {
    if (!confirm ('Yakin untuk ganti perangkat ? ')){
      return;
    }

    console.log(this.changePackageForm.value);
    this._newDevice = this.changePackageForm.value;
    console.log({customer: this._oldDevice.id, old:this._oldDevice, new : this._newDevice});
      
    this.changedeviceloading = true;

    
    this.partnerService.PostChangePackagePrepaid({customer: this._oldDevice.id, old:this._oldDevice, new : this._newDevice}).subscribe((output: any) => {
      console.log(output);
      if ( output.status ){
        this.router.navigate(["customers/services/"+ this._oldDevice.id]);
      }else{
        alert('ERROR : '+output.message);
      }
      
      //this.CustomerList = output;
       this.changedeviceloading = false;
    })
  }

  changeSubmit()
  {

    console.log(this.changePackageForm.value);
    this._newDevice = this.changePackageForm.value;
    console.log({customer: this._oldDevice.id, old:this._oldDevice, new : this._newDevice});
    this.changedeviceloading = true;
    this.partnerService.PostChangePackage({customer: this._oldDevice.id, old:this._oldDevice, new : this._newDevice}).subscribe((output: {}) => {
    console.log(output);
      //this.CustomerList = output;
       this.changedeviceloading = false;
    })
  }

  onCloseFormChangepackage()
  {
    this.changeForm = false;
  }
  
  isSNStb(item)
  {
    if (item.stb == null){
      return '';
    }else{
      return item.stb.sn;
    }
  }

  isMacStb(item)
  {
    if (item.stb == null){
      return '';
    }else{
      return item.stb.macaddress;
    }
  }

  // Issues list
  loadCustomeractive(params: any) {
    this.table_load = true
    return this.partnerService.GetCustomerActive(params).subscribe((output: any) => {
    console.log(output);
      this.table_load = false
      this.CustomerList = output.data;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      
      this.first_index = ((self-1)*this.meta['perPage'])+1;

    })
  }

  _services(item: any)
  {
    if ( item.services == null)
    {
      return '';
    }
    let service = '';
    item.services.forEach(function (value) {
      service += value.servicename + '\n';
    });

    return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    
  }

}
